<template>
  <div
    class="flex flex-col gap-5 md:!max-h-[462px] !max-h-[70dvh] overflow-y-scroll max-md:pt-5 filter-section"
  >
    <template
      v-if="
        selectedAttributes.length ||
        selectedLabels.length ||
        selectedCategories.length ||
        city.id ||
        minPrice ||
        maxPrice ||
        selectedRate
      "
    >
      <span
        class="max-md:px-5 md:text-heading-4 text-mobile-heading-4 text-primary-1"
      >
        {{ t("discover.appliedFilters") }}
      </span>
      <div class="max-md:px-5 flex flex-wrap gap-2.5">
        <div
          v-for="item in [
            ...selectedAttributes,
            ...selectedLabels,
            ...selectedCategories,
          ]"
          :key="item.value"
          class="selected-tag bg-white"
          @click="handleSelect({ item, isChecked: false }, item.type)"
        >
          <span class="text-primary-1 md:text-heading-6 text-mobile-heading-6">
            {{ item.title }}
          </span>
          <icon-close class="mt-0.5 text-[10px] text-gray-1 cursor-pointer" />
        </div>
        <div
          v-if="selectedRate"
          class="selected-tag bg-white"
          @click="selectedRate = undefined"
        >
          <span class="text-primary-1 md:text-heading-6 text-mobile-heading-6">
            {{ selectedRate }}
          </span>
          <icon-close class="mt-0.5 text-[10px] text-gray-1 cursor-pointer" />
        </div>
        <div v-if="city.id" class="selected-tag bg-white" @click="resetCity()">
          <span class="text-primary-1 md:text-heading-6 text-mobile-heading-6">
            {{ city.title }}
          </span>
          <icon-close class="mt-0.5 text-[10px] text-gray-1 cursor-pointer" />
        </div>
        <div
          v-if="maxPrice || minPrice"
          class="selected-tag bg-white text-primary-1 md:text-heading-6 text-mobile-heading-6"
        >
          <span>
            {{ currencyCode }}
            {{ minPrice }}
            -
            {{ currencyCode }}
            {{ maxPrice }}
          </span>
          <icon-close
            class="mt-0.5 text-[10px] text-gray-1 cursor-pointer"
            @click="removePriceFilter"
          />
        </div>
      </div>
      <hr class="text-gray-3" />
    </template>
    <LazyDiscoverFilterCity
      v-if="!route.params.slug"
      class="max-md:px-5"
      :title="t('discover.city')"
      :selected="city"
      :cities="cities"
      @select-city="selectedCity"
    />
    <hr class="text-gray-3" />
    <template v-if="timeOfDay?.values?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.timeOfTheDay')"
        :items="
          timeOfDay.values.map((val) => ({ title: val.value, value: val.slug }))
        "
        :selecteds="selectedAttributes"
        @update:checked="handleSelect({ ...$event, slug: 'best-time' }, 'attr')"
      />
      <hr class="text-gray-3" />
    </template>

    <template v-if="props.facets?.labels?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.labels')"
        :items="
          props.facets.labels.map((val) => ({
            title: val.value,
            value: val.slug,
          }))
        "
        :selecteds="selectedLabels"
        @update:checked="handleSelect($event, 'label')"
      />
      <hr class="text-gray-3" />
    </template>
    <template v-if="subCategories.length">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.categories')"
        :items="
          subCategories.map((val) => ({ title: val.title, value: val.slug }))
        "
        :selecteds="selectedCategories"
        @update:checked="handleSelect($event, 'category')"
      />
      <hr class="text-gray-3" />
    </template>

    <LazyDiscoverFilterPrice
      class="max-md:px-5"
      :title="t('discover.price')"
      v-model:min="minPrice"
      v-model:max="maxPrice"
      :min-price="facets.price_range.min_price"
      :max-price="facets.price_range.max_price"
    />
    <hr class="text-gray-3" />

    <template v-if="duration?.values?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        v-if="duration?.values?.length > 0"
        :title="t('discover.duration')"
        :items="
          duration.values.map((val) => ({ title: val.value, value: val.slug }))
        "
        :selecteds="selectedAttributes"
        @update:checked="handleSelect({ ...$event, slug: 'duration' }, 'attr')"
      />
      <hr class="text-gray-3" />
    </template>

    <template v-if="bestFor?.values?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.bestFor')"
        :items="
          bestFor.values.map((val) => ({ title: val.value, value: val.slug }))
        "
        :selecteds="selectedAttributes"
        @update:checked="
          handleSelect({ ...$event, slug: 'perfect-for' }, 'attr')
        "
      />
      <hr class="text-gray-3" />
    </template>

    <template v-if="ageRange?.values?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.ageRange')"
        :items="
          ageRange.values.map((val) => ({ title: val.value, value: val.slug }))
        "
        :selecteds="selectedAttributes"
        @update:checked="handleSelect({ ...$event, slug: 'age-range' }, 'attr')"
      />
      <hr class="text-gray-3" />
    </template>

    <template v-if="transport?.values?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.transportation')"
        :items="
          transport.values.map((val) => ({ title: val.value, value: val.slug }))
        "
        :selecteds="selectedAttributes"
        @update:checked="handleSelect({ ...$event, slug: 'transport' }, 'attr')"
      />
      <hr class="text-gray-3" />
    </template>

    <template v-if="occasion?.values?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.occasion')"
        :items="
          occasion.values.map((val) => ({ title: val.value, value: val.slug }))
        "
        :selecteds="selectedAttributes"
        @update:checked="handleSelect({ ...$event, slug: 'occasion' }, 'attr')"
      />
      <hr class="text-gray-3" />
    </template>

    <template v-if="language?.values?.length > 0">
      <LazyDiscoverFilterSection
        class="max-md:px-5"
        :title="t('discover.language')"
        :items="
          language.values.map((val) => ({ title: val.value, value: val.slug }))
        "
        :selecteds="selectedAttributes"
        @update:checked="handleSelect({ ...$event, slug: 'languages' }, 'attr')"
      />
      <hr class="text-gray-3" />
    </template>

    <!-- <LazyDiscoverFilterStarRating
      :title="t('discover.starRating')"
      class="max-md:px-5"
      :items="starRatingOptions"
      :selected="selectedRate"
      @update:selected="selectedRate = $event"
    />
    <hr class="text-gray-3" /> -->
  </div>
  <div class="flex gap-3.5 mt-4 max-md:px-5">
    <BaseButton
      :disabled="
        !Boolean(
          selectedAttributes.length ||
            selectedLabels.length ||
            selectedCategories.length ||
            minPrice ||
            maxPrice ||
            selectedRate
        )
      "
      type="outlined"
      class="!w-full"
      :label="t('discover.resetAll')"
      @click="emit('reset-all')"
    />

    <!-- :disabled="
        !Boolean(
          selectedAttributes.length ||
            selectedLabels.length ||
            selectedCategories.length
        )
      " -->
    <BaseButton
      class="!w-full"
      :label="t('discover.showResults')"
      @click="emit('show-result')"
    />
  </div>
</template>

<script setup lang="ts">
import type { IOptions, ICity, IApiResponse } from "../../types/general";
import { onMounted, ref, watch, type PropType } from "vue";
import { useRoute, useRouter } from "vue-router";
import groupBy from "lodash.groupby";

const props = defineProps({
  facets: {
    type: Object,
    required: true,
  },
  cities: { type: Array as PropType<ICity[]>, default: [] },
});
const route = useRoute();
const router = useRouter();
const city = ref<IOptions>({
  id: "",
  title: "",
});
onMounted(() => {
  if (route.query?.city) {
    if (props.cities.find((item) => item.slug == route.query?.city)) {
      city.value = props.cities
        ?.filter((item) => item.slug === route.query?.city)
        .map((x) => ({ id: x.slug, title: x.name }))[0];
    }
  }
});
const minPrice = ref();
const maxPrice = ref();
const currencyCode = ref(props.facets.price_range.max_price.currency.code);

const localePath = useLocalePath();
const { t } = useI18n();
const emit = defineEmits([
  "reset-all",
  "show-result",
  "scroll-to-activities",
  "select-city",
]);
function removePriceFilter() {
  minPrice.value = 0;
  maxPrice.value = 0;
}

const subCategories = props.facets.categories
  .flatMap((category) => category.sub_categories)
  .filter(Boolean)
  .sort(
    (subCategoryOne, subCategoryTwo) =>
      subCategoryTwo.product_count - subCategoryOne.product_count
  );

const timeOfDay = props.facets.attributes.find(
  (att) => att.slug == "best-time"
);
// const price = props.facets.attributes.find((att) => att.key == "Pricing-Label");
const duration = props.facets.attributes.find((att) => att.slug == "duration");
const bestFor = props.facets.attributes.find(
  (att) => att.slug == "perfect-for"
);
const ageRange = props.facets.attributes.find((att) => att.slug == "age-range");
const transport = props.facets.attributes.find(
  (att) => att.slug == "transport"
);
const occasion = props.facets.attributes.find((att) => att.slug == "occasion");
const language = props.facets.attributes.find((att) => att.slug == "languages");
// const starRatingOptions = ["3", "4", "5"];

const selectedAttributes = ref<
  {
    title: string;
    value: number;
    type: "attr" | "category" | "label";
    slug: string;
  }[]
>([]);
const selectedLabels = ref<
  { title: string; value: number; type: "attr" | "category" | "label" }[]
>([]);
const selectedCategories = ref<
  { title: string; value: number; type: "attr" | "category" | "label" }[]
>([]);
const selectedRate = ref<number>();

const handleSelect = (
  { item, isChecked, slug }: { item: any; isChecked: boolean; slug?: string },
  type: "attr" | "category" | "label"
) => {
  const selectedArray =
    type === "attr"
      ? selectedAttributes
      : type === "label"
        ? selectedLabels
        : selectedCategories;

  if (!isChecked) {
    selectedArray.value = selectedArray.value.filter(
      (selected) => selected.value !== item.value
    );
  } else if (
    !selectedArray.value.some((selected) => selected.value === item.value)
  ) {
    selectedArray.value.push({ ...item, type, slug });
  }
};

watch(
  [
    selectedAttributes,
    selectedLabels,
    selectedCategories,
    selectedRate,
    minPrice,
    maxPrice,
    city,
  ],
  () => {
    const currentQuery = { ...router.currentRoute.value.query };
    delete currentQuery["best-time"];
    delete currentQuery["duration"];
    delete currentQuery["perfect-for"];
    delete currentQuery["age-range"];
    delete currentQuery["transport"];
    delete currentQuery["occasion"];
    delete currentQuery["languages"];

    if (selectedAttributes.value.length) {
      Object.entries(groupBy(selectedAttributes.value, "slug")).map(
        ([key, value]) => {
          if (key != "undefined")
            currentQuery[key] = (value as any)
              .flatMap((item) => item.value)
              .join(",");
        }
      );
    }

    if (selectedLabels.value.length) {
      currentQuery.labels = selectedLabels.value
        .flatMap((item) => item.value)
        .join(",");
    } else {
      delete currentQuery.labels;
    }

    if (selectedCategories.value.length) {
      currentQuery.category = selectedCategories.value
        .flatMap((item) => item.value)
        .join(",");
    } else {
      delete currentQuery.category;
    }
    if (city.value.id) {
      currentQuery.city = String(city.value.id);
    } else {
      delete currentQuery.city;
    }
    if (selectedRate.value) {
      currentQuery.rate = String(selectedRate.value);
    } else {
      delete currentQuery.rate;
    }
    if (minPrice.value) {
      currentQuery.price_range = `${minPrice.value}-${maxPrice.value}`;
    } else {
      delete currentQuery.price_range;
    }

    router.push(localePath({ query: currentQuery }));
    emit("scroll-to-activities");
  },
  {
    deep: true,
  }
);

watch(
  () => route.query,
  () => {
    if (props.facets.attributes) {
      const tmp: any = [];
      if (route.query["best-time"]) {
        const found = props.facets.attributes.find(
          (att) => att.slug == "best-time"
        );
        tmp.push(
          ...found.values
            .filter((attr) =>
              route.query["best-time"]
                ?.toString()
                .split(",")
                .some((val) => val == attr.slug)
            )
            .map((attr) => ({
              title: attr.value,
              value: attr.slug,
              slug: found.slug,
              type: "attr",
            }))
        );
      }
      if (route.query["duration"]) {
        const found = props.facets.attributes.find(
          (att) => att.slug == "duration"
        );

        tmp.push(
          ...found.values
            .filter((attr) =>
              route.query["duration"]
                ?.toString()
                .split(",")
                .some((val) => val == attr.slug)
            )
            .map((attr) => ({
              title: attr.value,
              value: attr.slug,
              slug: found.slug,
              type: "attr",
            }))
        );
      }
      if (route.query["perfect-for"]) {
        const found = props.facets.attributes.find(
          (att) => att.slug == "perfect-for"
        );
        tmp.push(
          ...found.values
            .filter((attr) =>
              route.query["perfect-for"]
                ?.toString()
                .split(",")
                .some((val) => val == attr.slug)
            )
            .map((attr) => ({
              title: attr.value,
              value: attr.slug,
              slug: found.slug,
              type: "attr",
            }))
        );
      }
      if (route.query["age-range"]) {
        const found = props.facets.attributes.find(
          (att) => att.slug == "age-range"
        );
        tmp.push(
          ...found.values
            .filter((attr) =>
              route.query["age-range"]
                ?.toString()
                .split(",")
                .some((val) => val == attr.slug)
            )
            .map((attr) => ({
              title: attr.value,
              value: attr.slug,
              slug: found.slug,
              type: "attr",
            }))
        );
      }
      if (route.query["transport"]) {
        const found = props.facets.attributes.find(
          (att) => att.slug == "transport"
        );
        tmp.push(
          ...found.values
            .filter((attr) =>
              route.query["transport"]
                ?.toString()
                .split(",")
                .some((val) => val == attr.slug)
            )
            .map((attr) => ({
              title: attr.value,
              value: attr.slug,
              slug: found.slug,
              type: "attr",
            }))
        );
      }
      if (route.query["occasion"]) {
        const found = props.facets.attributes.find(
          (att) => att.slug == "occasion"
        );
        tmp.push(
          ...found.values
            .filter((attr) =>
              route.query["occasion"]
                ?.toString()
                .split(",")
                .some((val) => val == attr.slug)
            )
            .map((attr) => ({
              title: attr.value,
              value: attr.slug,
              slug: found.slug,
              type: "attr",
            }))
        );
      }
      if (route.query["languages"]) {
        const found = props.facets.attributes.find(
          (att) => att.slug == "languages"
        );
        tmp.push(
          ...found.values
            .filter((attr) =>
              route.query["languages"]
                ?.toString()
                .split(",")
                .some((val) => val == attr.slug)
            )
            .map((attr) => ({
              title: attr.value,
              value: attr.slug,
              slug: found.slug,
              type: "attr",
            }))
        );
      }

      selectedAttributes.value = tmp;
    }
    if (route.query.labels && props.facets.labels)
      selectedLabels.value = props.facets.labels
        .filter((label) =>
          route.query.labels
            ?.toString()
            .split(",")
            .some((val) => val == label.slug)
        )
        .map((label) => ({
          title: label.value,
          value: label.slug,
          type: "label",
        }));

    if (route.query.category && props.facets.categories)
      selectedCategories.value = props.facets.categories
        .flatMap((category) => category.sub_categories)
        .filter((category) =>
          route.query.category
            ?.toString()
            .split(",")
            .some((val) => val == category.slug)
        )
        .map((category) => ({
          title: category.title,
          value: category.slug,
          type: "category",
        }));

    if (route.query.rate && Number(route.query.rate ?? 0) > 0)
      selectedRate.value = Number(route.query.rate);

    if (route.query.city) {
      const foundCity = props.cities.find(
        (city) => city.slug === route.query.city
      );
      city.value = foundCity
        ? { id: foundCity.slug, title: foundCity.name }
        : { id: "", title: "" };
    } else {
      city.value = { id: "", title: "" };
    }

    if (route.query.price_range) {
      const priceRange = route.query.price_range as string;
      [minPrice.value, maxPrice.value] = priceRange.split("-");
    }
  },
  { deep: true, immediate: true }
);
function selectedCity(val: IOptions) {
  if (val.id) {
    emit("select-city", val.id);
    city.value = val;
  }
}
function resetCity() {
  city.value = {
    id: "",
    title: "",
  };
}
</script>

<style lang="scss" scoped>
.selected-tag {
  @apply rounded-md border-[1px] border-gray-2 flex items-center w-fit cursor-pointer px-3.5 md:py-3 py-2 gap-2.5 transition-all duration-300 hover:bg-white;
  box-shadow: 0px 2px 3px 0px #0000000a;
}
.filter-section {
  padding-inline-end: 6px;

  &:hover {
    padding-inline-end: 0px;
  }

  &:hover::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar {
    width: 0px;
  }
}

::-webkit-scrollbar-thumb {
  @apply bg-gray-2 rounded-[50px];
}
</style>
